import { useEffect, useState } from 'react';
import { DELIMITER_REGEXP } from '@frameio/shared/constants';
import { parseEmails } from '@frameio/shared/utils/parseEmails';
import { removeZeroWidthCharactersFromString } from '@frameio/utils/formatters';

export const useMemberEmailInputQuery = ({
  onQueryChange,
  onEmailsEntered,
}: {
  onQueryChange: (query: string) => void;
  onEmailsEntered: (emails: string[]) => Promise<void>;
}) => {
  const [query, setQuery] = useState('');
  const [suppressOnChange, setSuppressOnChange] = useState(false);

  useEffect(() => {
    onQueryChange(query);
  }, [query, onQueryChange]);

  const handleQueryChange = async (
    evt: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (suppressOnChange) {
      setSuppressOnChange(false);
      return;
    }

    const value = removeZeroWidthCharactersFromString(evt.target.value);

    if (DELIMITER_REGEXP.test(value)) {
      const emails = value
        .split(DELIMITER_REGEXP)
        .map((email: string) => email.trim().toLowerCase())
        .filter(Boolean);

      await onEmailsEntered(emails);
      setQuery('');
      return;
    }

    setQuery(value);
  };

  const handleQueryPaste = async (
    evt: React.ClipboardEvent<HTMLInputElement>
  ) => {
    setSuppressOnChange(true);
    const value = removeZeroWidthCharactersFromString(
      evt.clipboardData.getData('text')
    );

    const emails = parseEmails(value);
    setQuery(emails.join());
    await onEmailsEntered(emails);
    setQuery('');
  };

  return {
    handleQueryChange,
    handleQueryPaste,
    query,
    resetQuery: () => setQuery(''),
  };
};
